import baseKey from './_baseKey';

const userDomainKey = (subDomains?: string[]) =>
  baseKey.domainKey('user', subDomains);

/**
 * 고객사 관련 쿼리키 제너레이터
 */
const userKey = {
  /**
   * @returns 유저 도메인 기본 쿼리키 (getter)
   * @example ['user']
   */
  domain() {
    return userDomainKey();
  },
  /**
   * @param accessToken 유저 정보 조회 토큰
   * @returns 토큰에 대한 유저 상세 데이터 요청 쿼리키
   * @example ['user', 'detail', '1bsewdfsdf...']
   */
  detailByToken(accessToken?: string) {
    return [...baseKey.itemKey(userDomainKey(), 'detail'), accessToken];
  },
};

export default Object.freeze(userKey);
